<ngx-spinner size = "medium" color = "#fff" type = "ball-spin-fade" [fullScreen] = "true"></ngx-spinner>
<main>
  <div class="content">
    <app-header></app-header>
    <app-maintenance></app-maintenance>
    <app-search></app-search>
    <app-results></app-results>
  </div>  
  <app-footer></app-footer>
</main>